
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("eIXcD"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("eIXcD", function(module, exports) {

let $ab8319330850e553$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab8319330850e553$var$load("5wVuh"),
    $ab8319330850e553$var$load("4NznW"),
    $ab8319330850e553$var$load("1F7LX"),
    $ab8319330850e553$var$load("fVkwb"),
    $ab8319330850e553$var$load("enBeB"),
    $ab8319330850e553$var$load("cjaF7"),
    $ab8319330850e553$var$load("gknbb"),
    $ab8319330850e553$var$load("6iz6l"),
    $ab8319330850e553$var$load("4SCW2"),
    $ab8319330850e553$var$load("36QeB"),
    $ab8319330850e553$var$load("9q75n"),
    $ab8319330850e553$var$load("iYHbd"),
    $ab8319330850e553$var$load("7aMek"),
    $ab8319330850e553$var$load("3q2Ng"),
    $ab8319330850e553$var$load("jRpDi"),
    $ab8319330850e553$var$load("hnGEQ"),
    $ab8319330850e553$var$load("3GuOt"),
    $ab8319330850e553$var$load("jbM5v"),
    $ab8319330850e553$var$load("dek7I"),
    $ab8319330850e553$var$load("dYtBN"),
    $ab8319330850e553$var$load("kNV5Y"),
    $ab8319330850e553$var$load("6SWFK"),
    $ab8319330850e553$var$load("9aQIt"),
    $ab8319330850e553$var$load("5zapo"),
    $ab8319330850e553$var$load("3MYQs"),
    $ab8319330850e553$var$load("XZauT"),
    $ab8319330850e553$var$load("4S1SF"),
    $ab8319330850e553$var$load("jiFtb"),
    $ab8319330850e553$var$load("lm9Lt"),
    $ab8319330850e553$var$load("9atVd"),
    $ab8319330850e553$var$load("9wPDc"),
    $ab8319330850e553$var$load("1MWOL"),
    $ab8319330850e553$var$load("6fQco"),
    $ab8319330850e553$var$load("aOY32"),
    $ab8319330850e553$var$load("7jSfd"),
    $ab8319330850e553$var$load("4HZlX"),
    $ab8319330850e553$var$load("kDqHr"),
    $ab8319330850e553$var$load("6wr18"),
    $ab8319330850e553$var$load("gT8XU"),
    $ab8319330850e553$var$load("8bhm4"),
    $ab8319330850e553$var$load("ffEVr"),
    $ab8319330850e553$var$load("7EorR"),
    $ab8319330850e553$var$load("8k9aB"),
    $ab8319330850e553$var$load("fLwVm"),
    $ab8319330850e553$var$load("kuFG2"),
    $ab8319330850e553$var$load("hhss7"),
    $ab8319330850e553$var$load("Wowvf"),
    $ab8319330850e553$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("1d6ec"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("1d6ec", function(module, exports) {

let $0e1bd61b1b342fad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0e1bd61b1b342fad$var$load("6wr18"),
    $0e1bd61b1b342fad$var$load("7aMek"),
    $0e1bd61b1b342fad$var$load("8bhm4"),
    $0e1bd61b1b342fad$var$load("ffEVr"),
    $0e1bd61b1b342fad$var$load("2tIxk"),
    $0e1bd61b1b342fad$var$load("dLq4a"),
    $0e1bd61b1b342fad$var$load("hhss7"),
    $0e1bd61b1b342fad$var$load("aQh37"),
    $0e1bd61b1b342fad$var$load("bJVDE"),
    $0e1bd61b1b342fad$var$load("8k9aB"),
    $0e1bd61b1b342fad$var$load("fLwVm"),
    $0e1bd61b1b342fad$var$load("kuFG2"),
    $0e1bd61b1b342fad$var$load("1F7LX"),
    $0e1bd61b1b342fad$var$load("cjaF7"),
    $0e1bd61b1b342fad$var$load("h3ABO"),
    $0e1bd61b1b342fad$var$load("kC80R"),
    $0e1bd61b1b342fad$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("dSUFC"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("dSUFC", function(module, exports) {

let $a1bc4708c4bdad82$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a1bc4708c4bdad82$var$load("j4FoV"),
    $a1bc4708c4bdad82$var$load("lRfiO"),
    $a1bc4708c4bdad82$var$load("fuks3"),
    $a1bc4708c4bdad82$var$load("b9CA3"),
    $a1bc4708c4bdad82$var$load("2YffH"),
    $a1bc4708c4bdad82$var$load("lUDr0"),
    $a1bc4708c4bdad82$var$load("8dwgS"),
    $a1bc4708c4bdad82$var$load("9XOeB"),
    $a1bc4708c4bdad82$var$load("xu7ej"),
    $a1bc4708c4bdad82$var$load("iQ4FP"),
    $a1bc4708c4bdad82$var$load("71gca"),
    $a1bc4708c4bdad82$var$load("bFPFr"),
    $a1bc4708c4bdad82$var$load("82Jpo"),
    $a1bc4708c4bdad82$var$load("d2YjW"),
    $a1bc4708c4bdad82$var$load("im1VN"),
    $a1bc4708c4bdad82$var$load("6WAC7"),
    $a1bc4708c4bdad82$var$load("czOM6"),
    $a1bc4708c4bdad82$var$load("jWHz7"),
    $a1bc4708c4bdad82$var$load("7o9KM"),
    $a1bc4708c4bdad82$var$load("j8WjL"),
    $a1bc4708c4bdad82$var$load("8auEH"),
    $a1bc4708c4bdad82$var$load("4S9KJ"),
    $a1bc4708c4bdad82$var$load("hKRLP"),
    $a1bc4708c4bdad82$var$load("9anPW"),
    $a1bc4708c4bdad82$var$load("3EXzu"),
    $a1bc4708c4bdad82$var$load("b2FtX"),
    $a1bc4708c4bdad82$var$load("gnDXu"),
    $a1bc4708c4bdad82$var$load("dl2qY"),
    $a1bc4708c4bdad82$var$load("kL5FA"),
    $a1bc4708c4bdad82$var$load("6iz6l"),
    $a1bc4708c4bdad82$var$load("4SCW2"),
    $a1bc4708c4bdad82$var$load("9q75n"),
    $a1bc4708c4bdad82$var$load("iYHbd"),
    $a1bc4708c4bdad82$var$load("3q2Ng"),
    $a1bc4708c4bdad82$var$load("jRpDi"),
    $a1bc4708c4bdad82$var$load("5wVuh"),
    $a1bc4708c4bdad82$var$load("4NznW"),
    $a1bc4708c4bdad82$var$load("7hmKj"),
    $a1bc4708c4bdad82$var$load("14Bh4"),
    $a1bc4708c4bdad82$var$load("c0JsV"),
    $a1bc4708c4bdad82$var$load("h3ABO"),
    $a1bc4708c4bdad82$var$load("gYQRR"),
    $a1bc4708c4bdad82$var$load("4XdkL"),
    $a1bc4708c4bdad82$var$load("4eock"),
    $a1bc4708c4bdad82$var$load("8k9aB"),
    $a1bc4708c4bdad82$var$load("fLwVm"),
    $a1bc4708c4bdad82$var$load("6wr18"),
    $a1bc4708c4bdad82$var$load("35cvG"),
    $a1bc4708c4bdad82$var$load("Wowvf"),
    $a1bc4708c4bdad82$var$load("2tIxk"),
    $a1bc4708c4bdad82$var$load("dLq4a"),
    $a1bc4708c4bdad82$var$load("ffEVr"),
    $a1bc4708c4bdad82$var$load("hhss7"),
    $a1bc4708c4bdad82$var$load("aQh37"),
    $a1bc4708c4bdad82$var$load("bJVDE"),
    $a1bc4708c4bdad82$var$load("1F7LX"),
    $a1bc4708c4bdad82$var$load("cjaF7"),
    $a1bc4708c4bdad82$var$load("jnVKv"),
    $a1bc4708c4bdad82$var$load("7EorR"),
    $a1bc4708c4bdad82$var$load("bgHzk"),
    $a1bc4708c4bdad82$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.c248baed.js.map
